import script from "./ApplicationsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationsList.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationsList.vue?vue&type=style&index=0&id=63601167&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63601167"]])

export default __exports__